// filter_modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form"]

    connect() {
        const tableId = this.element.id.replace("_filters_modal", "")
        const stateKey = `datatable:${tableId}:state`
        const saved = localStorage.getItem(stateKey)

        this.element.addEventListener("hidden.bs.modal", this.onHidden)

        if (!saved) return

        const state = JSON.parse(saved)
        if (!state.filters) return

        Object.entries(state.filters).forEach(([key, value]) => {
            const input = this.formTarget.querySelector(`[name="${key}"]`)

            if (!input) {
            // 🔥 multi-select
            const multi = this.formTarget.querySelector(
                `[name="${key}[]"]`
            )

            if (multi && Array.isArray(value)) {
                Array.from(multi.options).forEach(option => {
                option.selected = value.includes(option.value)
                })
            }

            return
            }

            input.value = value
        })
    }

    disconnect() {
        this.element.removeEventListener("hidden.bs.modal", this.onHidden)
    }

    // Sync badge from localStorage state when modal closes (e.g. via X button)
    onHidden = () => {
        const tableId = this.element.id.replace("_filters_modal", "")
        const stateKey = `datatable:${tableId}:state`
        const state = JSON.parse(localStorage.getItem(stateKey) || "{}")
        const count = Object.keys(state.filters || {}).length

        const card = document.getElementById(tableId)?.closest(".card")
        const badge = card?.querySelector("[data-filter-count]")
        if (badge) {
            badge.textContent = count
            badge.classList.toggle("d-none", count === 0)
        }
    }

    apply(event) {
        event.preventDefault()

        const filters = this.serialize()

        window.dispatchEvent(
            new CustomEvent("filters:apply", {
            detail: filters
            })
        )

        const modal = bootstrap.Modal.getInstance(this.element)
        if (modal) modal.hide()
    }

    clear(event) {
        event.preventDefault()

        // 1. limpa inputs do modal
        this.formTarget.reset()

        // 2. dispara evento vazio e sinaliza ao datatable para limpar busca também
        const tableId = this.element.id.replace("_filters_modal", "")
        window.dispatchEvent(new CustomEvent("filters:apply", { detail: {} }))
        window.dispatchEvent(new CustomEvent("datatable:clear-search", { detail: { tableId } }))

        // 3. fecha modal
        const modal = bootstrap.Modal.getInstance(this.element)
        if (modal) modal.hide()
    }


    serialize() {
        const data = new FormData(this.formTarget)
        const result = {}

        for (let [key, value] of data.entries()) {
            if (!value) continue

            // 🔥 trata multi-select
            if (key.endsWith("[]")) {
            const cleanKey = key.replace("[]", "")
            result[cleanKey] ||= []
            result[cleanKey].push(value)
            } else {
            result[key] = value
            }
        }

        return result
    }
}
